import { Sparkles } from "lucide-react";
import { BETA_LABEL, BETA_MESSAGE, BETA_MODE } from "@/lib/beta";

const BetaBanner = () => {
  if (!BETA_MODE) return null;
  return (
    <div className="fixed top-16 left-0 right-0 z-40 bg-primary/15 backdrop-blur border-b border-primary/30">
      <div className="container mx-auto px-4 py-2 flex flex-wrap items-center justify-center gap-2 text-xs sm:text-sm">
        <span className="font-bold text-primary inline-flex items-center gap-1">
          <Sparkles className="w-3.5 h-3.5" /> {BETA_LABEL}
        </span>
        <span className="text-foreground/80">{BETA_MESSAGE}</span>
      </div>
    </div>
  );
};

export default BetaBanner;
